module.exports = __webpack_public_path__ + "img/登基·桌子上的开国大典 v3.33b4ff2e.png";